import React, { useState } from 'react';
import { Box } from '@mui/material';
import {
  MarketShell, useMarketData, LineChartBox, BarChartBox,
} from './_shared';
import { ChartSection, StatCard, formatMWh, formatMW } from '../charts/shared';

const fmtDay = (iso) =>
  new Date(iso + 'T00:00:00').toLocaleDateString('en-AU', { day: '2-digit', month: 'short' });

export default function MarketBattery() {
  const [days, setDays] = useState(180);
  const { data, loading, error } = useMarketData('battery', days);

  let body = null;
  if (data) {
    const s = data.series || [];
    const x = s.map((r) => fmtDay(r.date));
    const last = s[s.length - 1] || {};
    const totDis = s.reduce((a, r) => a + (r.discharge_mwh || 0), 0);
    const rteVals = s.filter((r) => r.rte_pct != null).map((r) => r.rte_pct);
    const avgRte = rteVals.length ? rteVals.reduce((a, b) => a + b, 0) / rteVals.length : null;

    const energySeries = [
      { data: s.map((r) => r.discharge_mwh), label: 'Discharge', color: '#D98A2B' },
      { data: s.map((r) => r.charge_mwh), label: 'Charge', color: '#3b82f6' },
    ];
    const opsSeries = [
      { data: s.map((r) => r.avg_fcas_mw), label: 'Avg FCAS-enabled (MW)', color: '#8b5cf6',
        showMark: false, connectNulls: true },
      { data: s.map((r) => r.avg_soc_mwh), label: 'Avg state of charge (MWh)', color: '#14b8a6',
        showMark: false, connectNulls: true },
    ];

    body = (
      <>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 3 }}>
          <StatCard label="Active battery DUIDs" value={last.active_duids ?? '—'}
            unit="dispatching" color="#D98A2B" />
          <StatCard label="Avg round-trip" value={avgRte == null ? '—' : `${avgRte.toFixed(0)}%`}
            unit="discharge ÷ charge" />
          <StatCard label="Total discharge"
            value={totDis >= 1000 ? `${(totDis / 1000).toFixed(1)}` : totDis.toFixed(0)}
            unit={totDis >= 1000 ? 'GWh (window)' : 'MWh (window)'} />
        </Box>

        <ChartSection title="Fleet charge vs discharge"
          subtitle="NEM battery fleet (registered storage DUIDs), daily energy (MWh)">
          <BarChartBox x={x} series={energySeries} yFormat={formatMWh} />
        </ChartSection>

        <ChartSection title="FCAS enablement & state of charge"
          subtitle="Fleet-mean RAISEREG+LOWERREG enabled capacity and energy storage">
          <LineChartBox x={x} series={opsSeries} yFormat={formatMW} height={340} />
        </ChartSection>
      </>
    );
  }

  return (
    <MarketShell
      title="Battery & Storage"
      subtitle="NEM battery fleet operations — real AEMO dispatch actuals"
      days={days} setDays={setDays} loading={loading} error={error}
    >
      {body}
    </MarketShell>
  );
}
